import api from '../../API';
import { IntegrationConnection } from '../../types';

export default {
  async findAll(accountId: number): Promise<IntegrationConnection[]> {
    const response = await api.get(`accounts/${accountId}/integration-connections`);
    return response.data;
  },
};
